import { render, staticRenderFns } from "./AnswerClient.vue?vue&type=template&id=b4d7dc04&scoped=true"
import script from "./AnswerClient.vue?vue&type=script&lang=js"
export * from "./AnswerClient.vue?vue&type=script&lang=js"
import style0 from "./AnswerClient.vue?vue&type=style&index=0&id=b4d7dc04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d7dc04",
  null
  
)

export default component.exports